import * as React from 'react';

export interface ButtonProps {
	background?: string;
}

export const Button = ({ background = 'blue' }: ButtonProps) => {
	return <button style={{ background }}>Boop</button>;
};
